export const OPEN_VIEWPORT_CONTROLS = 'holzcom:open-viewport-controls';
export type ViewportControlsGroup = 'projection' | 'layers' | 'dimensions' | 'environment';
export function openViewportControls(group: ViewportControlsGroup) {
  const event = new CustomEvent(OPEN_VIEWPORT_CONTROLS, { detail: group, cancelable: true });
  window.dispatchEvent(event);
  if (!event.defaultPrevented) throw new Error('VIEWPORT_CONTROLS_OWNER_UNAVAILABLE');
}
